import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import TaskItem from '../TaskItem';

const TaskList = ({ tasks }) => {
  const { t } = useTranslation();

  if (tasks.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography color="textSecondary">
          {t('ActivityCenter_NoActiveTasks')}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      {tasks.map((task) => (
        <TaskItem key={task.id} task={task} />
      ))}
    </>
  );
};

export default TaskList;
